import { Typography } from "@mui/material";
import theme from "../../../core/theme";
import SimpleTable from "../../../common/components/SimpleTable";
import {
	ChangeRequestBaseCard,
	ChangeRequestBaseCardProps,
} from "./ChangeRequestBaseCard";

export const style = {
	body: {
		title: {
			fontFamily: theme.typography.fontFamily,
			fontSize: "20px",
			fontWeight: "600",
		},
	},
};

export const ChangeRequestContractCard = ({
	changeRequest,
	...props
}: ChangeRequestBaseCardProps) => {
	return (
		<ChangeRequestBaseCard changeRequest={changeRequest} {...props}>
			<Typography sx={style.body.title}>
				Requested modifications
			</Typography>
			<SimpleTable
				headers={[
					{ label: "Field name", accessor: "path" },
					{
						label: "Old value",
						accessor: "old_value",
						format: (value: any) =>
							typeof value === "object"
								? JSON.stringify(value)
								: value,
					},
					{
						label: "New value",
						accessor: "value",
						format: (value: any) =>
							typeof value === "object"
								? JSON.stringify(value)
								: value,
					},
				]}
				items={(changeRequest?.diff_json || []).map((contractDiff) => {
					// Stringifying value in case of new values beeing a complete dict or list of dict
					return {
						...contractDiff,
						value: contractDiff.value,
						path: contractDiff.path.join("."),
					};
				})}
			/>
		</ChangeRequestBaseCard>
	);
};
